import {
    Button,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Typography,
    makeStyles,
} from "@material-ui/core";
import {
    Add,
} from "@material-ui/icons";
import { useDispatch, useSelector } from "react-redux";
import ItemsListEmpty from "./items-list-empty";
import ItemsListLoading from "./items-list-loading";
import { useEffect } from "react";
import { getItemsService } from "./items-list-service";
import { db } from "../../../../firebase";
import { showAddItemsDialog } from "../items-add/items-add-slice";
import { Link } from "react-router-dom";
import { showErrorSnackbar } from "../../../shared/snackbar/snackbar-slice";

const useStyles = makeStyles((theme) => ({
    tableHeader: {
      background: "#111111",
      height: "100%",
      color: "#fbbbd3",
      fontSize: 14,
    },
    button: {
      background: "#111111",
      color: "#fbbbd3",
      justifyContent: "right",
      '&:hover': {
        backgroundColor: '#fbbbd3',
        color: '#111111',
      },
    },
    buttonText: {
      color: "#111111",
      '&:hover': {
        backgroundColor: '#fbbbd3',
        color: '#111111',
    },
    },
    title: {
      color:"#111111",
      marginBottom: 20,
    }
}));

const ItemsList = () => {
    const classes = useStyles();
    const itemsCollection = useSelector((state) => state.itemsListSlice.rows);
    const isLoading = useSelector((state) => state.itemsListSlice.isLoading);
    const dispatch = useDispatch();

    // get data
    useEffect(() => {
        const fetchData = async () => {
            try {
                await getItemsService(dispatch, db, "items");
            } catch(e) {
                dispatch(showErrorSnackbar("Something went wrong while trying to fetch."));
                console.error("ItemsList fetchData error: ", e);
            }
        };
        fetchData();
    }, [dispatch]);

    // open add dialog
    const handleAddOpen = () => {
        dispatch(showAddItemsDialog());
    };

    // return loading state if isLoading is true
    if (isLoading) {
        return <ItemsListLoading/>
    }

    // return empty state if isLoading is false and itemsCollection has no collection
    if (!isLoading && itemsCollection.length === 0) {
        return <ItemsListEmpty/>
    }

    return (
        <>
            <Typography className={classes.title} variant="h4">Items</Typography>
            <div style={{ display: "flex", alignItems: "center", marginBottom: 10}}>
                <Button
                    variant="contained"
                    className={classes.button}
                    startIcon={<Add/>}
                    onClick={handleAddOpen}
                >
                    Add
                </Button>
            </div>
            
            <TableContainer component={Paper}>
                <Table sx={{ minWidth: 700 }} aria-label="customized table">
                    <TableHead>
                        <TableRow>
                            <TableCell align="left" className={classes.tableHeader}>Code</TableCell>
                            <TableCell align="left" className={classes.tableHeader}>Name</TableCell>
                            <TableCell align="left" className={classes.tableHeader}>Type | Category</TableCell>
                            <TableCell align="left" className={classes.tableHeader}>Status</TableCell>
                            <TableCell align="left" className={classes.tableHeader}>Unit Price</TableCell>
                            <TableCell align="left" className={classes.tableHeader}>Rental Price</TableCell>
                            <TableCell align="left" className={classes.tableHeader}>Deposit</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {itemsCollection.map((row) => (
                            <TableRow
                                key={row.code}
                                component={Link}
                                to={`/admin/items/details/${row.id}`}
                                style={{ textDecoration: 'none' }}
                            >
                                <TableCell component="th" scope="row">
                                    {row.code}
                                </TableCell>
                                <TableCell align="left">{row.name}</TableCell>
                                <TableCell align="left">{`${row?.type} | ${row?.category}`}</TableCell>
                                <TableCell align="left">{row?.status}</TableCell>
                                <TableCell align="left">{row.unit_price}</TableCell>
                                <TableCell align="left">{row.rent_price}</TableCell>
                                <TableCell align="left">{row.deposit}</TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
        </>
        
    )
};

export default ItemsList;